import React, { useState, useEffect, useCallback } from "react"
import { iconsList as icons } from "./icons-list"
import { useActiveBlock } from "app/regions/hooks/use-active-block"

export function BlockIcon({ data, foreground, background, shape }) {
  const { url, icon } = data.properties
  const [src, setSrc] = useState(() =>
    assembleSrc(icon, foreground, background, shape)
  )
  const { setActiveBlockId } = useActiveBlock()

  // When the icon's settings change, retrieve a new image.
  useDebouncedEffect(
    () => setSrc(assembleSrc(icon, foreground, background, shape)),
    300,
    [icon, foreground, background, shape]
  )

  const handleClick = e => {
    e.preventDefault()
    e.stopPropagation()
    setActiveBlockId(data.block_id)
  }

  return (
    <a
      href={url}
      onClick={handleClick}
      style={{
        display: "inline-block",
        paddingRight: 8,
        border: "none",
        textDecoration: "none"
      }}
    >
      <img
        src={src}
        alt={icon}
        width="32"
        height="32"
        style={{
          width: 32,
          height: 32,
          display: "inline-block"
        }}
      />
      <outlook-only>&nbsp;</outlook-only>
    </a>
  )
}

export function getColors(icon, foreground, background, shape) {
  const accent = getIconColor(icon)

  if (shape === "icon-only") {
    return {
      foreground: foreground || accent,
      background: background || "ffffff"
    }
  } else {
    return {
      foreground: foreground || "ffffff",
      background: background || accent
    }
  }
}

function getIconColor(name) {
  const target = icons.find(icon => icon.name === name)

  if (!target) {
    console.error(`Couldn't find an icon matching "${name}".`)
    return "#000000"
  }

  return target.color
}

function useDebouncedEffect(effect, delay, dependencies) {
  const callback = useCallback(effect, dependencies)

  useEffect(() => {
    const handler = setTimeout(() => {
      callback()
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [callback, delay])
}

export function assembleSrc(icon, foreground, background, shape) {
  const colors = getColors(icon, foreground, background, shape)
  const formattedForeground = colors.foreground.replace("#", "")
  const formattedBackground = colors.background.replace("#", "")

  return `${process.env.NODE_FUNCTIONS_HOST}/icons?icon=${icon}&foreground=${formattedForeground}&background=${formattedBackground}&shape=${shape}&v=3`
}
